module.exports = __webpack_public_path__ + "static/img/explosion-proof.3b5ad090.webp";